import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { ObservationsService } from '../../../../services/table-management/observations.service';
import { ObservationsFormComponent } from '../observations-form/observations-form.component';

@Component({
  selector: 'app-observations-list',
  templateUrl: './observations-list.component.html',
  styleUrls: ['./observations-list.component.css'],
  providers:[ObservationsService],
  standalone: false,
})
export class ObservationsListComponent extends EntityListComponent<Rest.InvObservations> implements OnInit {

   @ViewChild(ObservationsFormComponent, { static: true })
    observationsForm: ObservationsFormComponent;
  
    title: string = this.translateService.instant('tableManagement.sinister.sinisterObservations');
    disableSave: boolean;
    EnabledFilter: SelectItem[];
    @Input() type: Rest.InvObservationsType;
    @Input() ids: number[] = [];
    @Input() entityId: number;
    isCreateGranted: boolean;
    isDeleteGranted: boolean;


    constructor(
      private observationsService: ObservationsService,
      protected confirmationService: ConfirmationService,
      public notificationsService: NotificationsService,
      protected i18n: I18nService,
      authenticationService: AuthenticationService,
      protected loadingService: LoadingService,
      protected userTime: UserTimePipe,
      protected excelService: ExcelService,
      protected translateService: TranslateService,
    ) {
      super(
        observationsService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
      );
      this.observationsService = observationsService;
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.form = this.observationsForm;
      this.setPermissions();

    }
    beforeLoad() {

      if(this.ids && this.ids.length > 0){
        this.paginationRequest.filters["ids"] = this.ids.map(id => id.toString());
      }
    }
  
    afterLoad() {
      
    }
    excelColumns = {};
    exportExcel() {
      this.setExcelColumns();
      let fileNameTitle = this.translateService.instant('tableManagement.sinister.sinisterObservations');
      super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
      const description = (entity: any) => entity.description ?? ''
      const date = (entity: any) => entity.date ?? ''

      this.excelColumns = {
        [this.translateService.instant('general.description')]: { bindField: description },
        [this.translateService.instant('general.date')]: { bindField: date },
      }
    }

    setPermissions() {
		    const user = this.authenticationService.user;
		    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_SINISTER_OBSERVATIONS_CREATE', user);
        this.isDeleteGranted = this.authenticationService.isRoleGranted('INV_SINISTER_OBSERVATIONS_DISABLE', user);

	  }

    onSaveCompleted(number){
      if(this.ids){
        this.ids.push(number);
      }else{
        this.ids = [number];
      }
      this.paginationRequest.filters["ids"] = this.ids.map(id => id.toString());

      this.refresh();
    }

    deleteObservation(observation){
      var that = this;
      this.observationsService.deleteById(observation.id).then((response) =>{
        if (response) {
          that.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
          that.refresh();
        } else {
          that.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'));
        }
      })

    }

    public onDeleteObservation(observation: Rest.InvObservations) {

		  if (this.isDeleteGranted === false) {
			  return;
		  }

		  this.confirmationService.confirm({
			  accept: () => {
				  this.deleteObservation(observation);
			  },
			  key: 'observations-list'
		  });
	  }

}

